import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { PageHeader } from '@/components/ui/PageHeader'
import { ProjectsBreadcrumbs } from '../ProjectsBreadcrumbs'
import { ProjectDatabricksNotebooksPageContent } from './ProjectDatabricksNotebooksPageContent'

export function ProjectDatabricksNotebooksPage() {
  return (
    <>
      <PageHeader className="shrink-0 pr-3" title={<ProjectsBreadcrumbs title="Databricks Notebooks" />} />
      <QueryErrorBoundary errorMessage="Failed to fetch project Databricks status">
        <ProjectDatabricksNotebooksPageContent />
      </QueryErrorBoundary>
    </>
  )
}
